import { Layout } from 'spa/components/layout'
import { ModuleLoader } from 'spa/components/module_loader/module_loader'
import React from 'react'

const Integrations = React.lazy(() => import('./integrations'))

const display = () => {
  return (
    <Layout fullWidth>
      <ModuleLoader>
        <Integrations />
      </ModuleLoader>
    </Layout>
  )
}

export { display as IntegrationsDisplay }

export { Integrations }

export default Integrations
